import "./InventorySelector.css";

import { useMemo } from "react";

import { ToggleTabs } from "../../wayfinding";

interface InventorySelectorProps {
  buttons: string[];
  activeSelector?: string;
  onChange?: (button: string) => void;
  disabled?: boolean;
}

export const InventorySelector = ({
  buttons,
  activeSelector,
  onChange,
  disabled = false,
}: InventorySelectorProps): JSX.Element => {
  const toggleTabsList = useMemo(() => buttons.map((label) => ({ label })), [buttons]);

  return (
    <div className="ButtonSlider">
      <ToggleTabs
        toggleTabsList={toggleTabsList}
        currentTab={activeSelector ?? toggleTabsList[0]?.label ?? ""}
        onChange={(value) => onChange?.(value)}
        variant="roundedSquare"
        size="medium"
        disabled={disabled}
      />
    </div>
  );
};
